/** Save a blob response as a file, named by the server's Content-Disposition when it sends one. */
export const downloadResponse = (response: { data: BlobPart; headers: Record<string, any> }, fallbackName: string): void => {
  const blob = new Blob([response.data], { type: response.headers['content-type'] });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  const match = (response.headers['content-disposition'] as string | undefined)?.match(/filename="?([^"]+)"?/);
  link.download = match?.[1] || fallbackName;
  link.click();
  window.URL.revokeObjectURL(link.href);
};

/**
 * Request a file and save it. When the request fails, the server's JSON
 * message — which arrives wrapped in a blob — becomes the error's message,
 * so the user sees why (e.g. "Print at most 200 transcripts at a time").
 */
export const fetchAndSave = async (
  request: () => Promise<{ data: BlobPart; headers: Record<string, any> }>,
  fallbackName: string,
): Promise<void> => {
  let response;
  try {
    response = await request();
  } catch (err: any) {
    const body = err?.response?.data;
    const message = body instanceof Blob ? await body.text().then(t => JSON.parse(t)?.message).catch(() => null) : null;
    throw new Error(message || err?.message || 'The download failed');
  }
  downloadResponse(response, fallbackName);
};
